import { render, staticRenderFns } from "./AirSense12Page.vue?vue&type=template&id=bda0650c&scoped=true&"
import script from "./AirSense12Page.vue?vue&type=script&lang=js&"
export * from "./AirSense12Page.vue?vue&type=script&lang=js&"
import style0 from "./AirSense12Page.vue?vue&type=style&index=0&id=bda0650c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda0650c",
  null
  
)

export default component.exports